import { render, staticRenderFns } from "./BaseUrlShare.vue?vue&type=template&id=70d0ad06&"
import script from "./BaseUrlShare.vue?vue&type=script&lang=js&"
export * from "./BaseUrlShare.vue?vue&type=script&lang=js&"
import style0 from "./BaseUrlShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports